module.exports = __webpack_public_path__ + "static/L2_visual_2_1_eg-615173b8ab9afe4344cba4ede0f1c260.png";